const companyEndpoints = {
  list: '/companies',
  detail: (companyId: string) => `/companies/${companyId}`
}

export default companyEndpoints
